<div class="fv2-panel" [class.fv2-panel--loading]="isLoading">

  <!-- Ordenar -->
  <ng-container *ngIf="orderByTypes?.length">
    <div class="fv2-group">
      <label class="fv2-label">Ordenar</label>
      <select class="fv2-select" name="OrderBy" [(ngModel)]="orderByField" (change)="ddOnChange($event)">
        <option value="">Sin orden</option>
        <option [value]="input.name" *ngFor="let input of orderByTypes">{{ input.filterName }}</option>
      </select>
    </div>
    <div class="fv2-group fv2-group--sm">
      <label class="fv2-label">Dirección</label>
      <select class="fv2-select" name="OrderByDescending" [(ngModel)]="orderByDescending">
        <option [ngValue]="false">↑ Asc</option>
        <option [ngValue]="true">↓ Desc</option>
      </select>
    </div>
    <div class="fv2-sep"></div>
  </ng-container>

  <!-- Filtros (todos inline, agrupados con label de sección si hay más de un grupo) -->
  <ng-container *ngFor="let group of filtersByGroup | keyvalue: returnZero">
    <ng-container *ngFor="let filter of group.value; trackBy: trackFilter">

      <!-- STRING -->
      <div *ngIf="filter.type == filterInputTypes.STRING && (requirements[filter.requirement] !== '' || filter.requirement == undefined)"
        class="fv2-group">
        <label class="fv2-label">{{ filter.filterName }}</label>
        <input class="fv2-input" [name]="filter.name" type="text" [placeholder]="filter.filterName"
          [(ngModel)]="fieldValues[filter.name]" />
      </div>

      <!-- NUMBER -->
      <div *ngIf="filter.type == filterInputTypes.NUMBER && (requirements[filter.requirement] !== '' || filter.requirement == undefined)"
        class="fv2-group fv2-group--sm">
        <label class="fv2-label">{{ filter.filterName }}</label>
        <input class="fv2-input" [name]="filter.name" type="number" [placeholder]="filter.filterName"
          [(ngModel)]="fieldValues[filter.name]" />
      </div>

      <!-- DATE -->
      <div *ngIf="filter.type == filterInputTypes.DATE && (requirements[filter.requirement] !== '' || filter.requirement == undefined)"
        class="fv2-group">
        <label class="fv2-label">{{ filter.filterName }}</label>
        <div class="fv2-date-group">
          <input class="fv2-input" [placeholder]="'dd/mm/aaaa'" [name]="filter.name"
            [(ngModel)]="dateValues[filter.name]" ngbDatepicker #dp="ngbDatepicker" />
          <button class="fv2-date-btn" type="button" (click)="dp.toggle()">
            <fa-icon [icon]="iconCalendar"></fa-icon>
          </button>
        </div>
      </div>

      <!-- OPTION -->
      <div *ngIf="filter.type == filterInputTypes.OPTION && (requirements[filter.requirement] !== '' || filter.requirement == undefined)"
        class="fv2-group">
        <label class="fv2-label">{{ filter.filterName }}</label>
        <select class="fv2-select" [name]="filter.name" [(ngModel)]="fieldValues[filter.name]"
          (change)="ddOnChange($event)">
          <option value="">—</option>
          <option [value]="ind + 1" *ngFor="let opt of filter.selectorOptions; let ind = index">{{ opt }}</option>
        </select>
      </div>

      <!-- MONEY -->
      <div *ngIf="filter.type == filterInputTypes.MONEY && (requirements[filter.requirement] !== '' || filter.requirement == undefined)"
        class="fv2-group fv2-group--sm">
        <label class="fv2-label">{{ filter.filterName }}</label>
        <select class="fv2-select" [name]="filter.name" [(ngModel)]="fieldValues[filter.name]"
          (change)="ddOnChange($event)">
          <option value="">—</option>
          <option value="1">Pesos</option>
          <option value="2">Dólares</option>
        </select>
      </div>

      <!-- BOOLEAN -->
      <div *ngIf="filter.type == filterInputTypes.BOOLEAN && (requirements[filter.requirement] !== '' || filter.requirement == undefined)"
        class="fv2-group fv2-group--sm">
        <label class="fv2-label">{{ filter.filterName }}</label>
        <select class="fv2-select" [name]="filter.name" [(ngModel)]="fieldValues[filter.name]"
          (change)="ddOnChange($event)">
          <option [ngValue]="''">—</option>
          <option [ngValue]="true">Sí</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>

      <!-- CHECKBOX -->
      <div *ngIf="filter.type == filterInputTypes.CHECKBOX && (requirements[filter.requirement] !== '' || filter.requirement == undefined)"
        class="fv2-group fv2-group--checkbox">
        <label class="fv2-label">&nbsp;</label>
        <label class="fv2-check-label">
          <input type="checkbox" class="fv2-check" [id]="'chk-' + filter.name" [name]="filter.name"
            [(ngModel)]="fieldValues[filter.name]" />
          {{ filter.filterName }}
        </label>
      </div>

    </ng-container>
  </ng-container>

  <!-- Acciones -->
  <div class="fv2-actions">
    <button type="button" class="fv2-btn fv2-btn--clear" (click)="deleteFilters()" [disabled]="isLoading"
      title="Limpiar filtros">
      <fa-icon [icon]="iconX"></fa-icon>
    </button>
    <button type="button" class="fv2-btn fv2-btn--apply" (click)="saveFilters()" [disabled]="isLoading">
      <fa-icon [icon]="isLoading ? iconSpinner : iconSearch" [class.fa-spin]="isLoading"></fa-icon>
      Filtrar
    </button>
  </div>

</div>
